import { Customizations } from 'models'

const historyTableLabels: Customizations = {
  vehicleNo: {
    label: 'No dossier',
    isDisplayed: true,
  },
  licensePlate: {
    label: 'Immat.',
    isDisplayed: true,
  },
  userId: {
    label: 'Id utilisateur',
    isDisplayed: true,
  },
  updateDateTime: {
    label: 'Date',
    isDisplayed: true,
  },
  reservePriceBefore: {
    label: 'Réserve avant',
    isDisplayed: true,
  },
  reservePriceAfter: {
    label: 'Réserve après',
    isDisplayed: true,
  },
  userDetails: {
    label: 'Utilisateur',
    isDisplayed: true,
  },
  // name: {
  //   label: 'Utilisateur',
  //   isDisplayed: true,
  // },
  // email: {
  //   label: 'Email',
  //   isDisplayed: true,
  // },

  userIp: {
    label: 'Adresse Ip',
    isDisplayed: true,
  },
}

export { historyTableLabels }
